import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/apiBase";

// Public booking window is always capped at this many days regardless of
// any admin-side "extra_days" the DB may hold. This keeps the customer
// availability strip and BookingForm calendar showing exactly the same
// horizon — 30 days — even if an admin has extended the internal window.
const PUBLIC_WINDOW_DAYS = 30;

/**
 * Fetches the current customer-facing booking-window length from the
 * backend once on mount, then clamps it to `PUBLIC_WINDOW_DAYS` so any
 * admin extension never leaks into public views.
 *
 * Returns `{ windowDays, loading }`. Defaults to 30 while the fetch is
 * in-flight so the calendar never renders an unbounded range.
 */
export const useBookingWindow = () => {
  const [windowDays, setWindowDays] = useState(PUBLIC_WINDOW_DAYS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/settings/booking-window`)
      .then((res) => {
        if (cancelled) return;
        const n = Number(res?.data?.window_days);
        if (Number.isFinite(n) && n > 0 && n < 400) {
          setWindowDays(Math.min(n, PUBLIC_WINDOW_DAYS));
        }
      })
      .catch(() => {
        /* fall back to default 30 */
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { windowDays, loading };
};
